@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.drawer {
  --drawer-desktop-padding-horiz: 40px;
  --drawer-mobile-padding-horiz: 24px;
  --drawer-padding-vert: 16px;

  z-index: var(--layers-drawer);
}

.rc-drawer-content {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.rc-drawer-mask {
  z-index: var(--layers-drawer);
}

.rc-drawer-mask--in {
  animation: fade-in 500ms linear;
}

.rc-drawer-mask--out {
  animation: fade-out 500ms linear;
}
